var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*eslint no-useless-escape: 0*/
import React, { useState, useEffect } from 'react';
import { Box, Button, IconButton, Typography, Grid, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from '@mui/material';
import { MODOS, getCodigoOfertaFormatada } from '../../../utils';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import ContainerPainel from '../../../components/container_painel';
import { BoxPrincipal, BoxBotoes } from '../../../components/form_box';
import { useNavigate, useParams } from 'react-router-dom';
import { BotaoFechar, BotaoAuxiliar } from '../../../components/botoes';
import { InputDados } from '../../../components/input_dados';
import { ModeEditOutlined as ModeEditOutlinedIcon } from '@mui/icons-material';
import GridComp from '../../../components/grid';
import { encerrarVagas, getVagasOferta, STATUS_API } from './selecao_profissionais.service';
import { ReeducandosSelecao } from '../../reecrutamentos/reeducandos';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { useAuth } from '../../../contexts/auth/AuthContext';
export var SelecaoVagas = function () {
    var _a, _b, _c, _d, _e, _f;
    var getFuncionalidadeExiste = useAuth().getFuncionalidadeExiste;
    var navigate = useNavigate();
    var _g = useState(true), loading = _g[0], setLoading = _g[1];
    var _h = useState(true), LoadingInicio = _h[0], setLoadingInicio = _h[1];
    var _j = useParams(), id = _j.id, modo = _j.modo;
    var _k = useState({}), Oferta = _k[0], setOferta = _k[1];
    var _l = useState([]), VagasOferta = _l[0], setVagasOferta = _l[1];
    var _m = useState({}), VagaSelecionada = _m[0], setVagaSelecionada = _m[1];
    var _o = useState([]), VagasSelecionadasGrid = _o[0], setVagasSelecionadasGrid = _o[1];
    var _p = useState(''), ObservacaoEncerramento = _p[0], setObservacaoEncerramento = _p[1];
    var _q = useState(false), PopupAberto = _q[0], setPopupAberto = _q[1];
    var _r = useState(false), PopupFinalizarAberto = _r[0], setPopupFinalizarAberto = _r[1];
    useEffect(function () {
        carregarDados();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var VagasOferta_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!id) return [3 /*break*/, 9];
                    _a = true;
                    switch (_a) {
                        case getFuncionalidadeExiste(FUNCIONALIDADES.ATENDIMENTOS_REGIME_FECHADO) && getFuncionalidadeExiste(FUNCIONALIDADES.ATENDIMENTOS_REGIME_SEMIABERTO): return [3 /*break*/, 1];
                        case getFuncionalidadeExiste(FUNCIONALIDADES.ATENDIMENTOS_REGIME_FECHADO): return [3 /*break*/, 3];
                        case getFuncionalidadeExiste(FUNCIONALIDADES.ATENDIMENTOS_REGIME_SEMIABERTO): return [3 /*break*/, 5];
                    }
                    return [3 /*break*/, 7];
                case 1: return [4 /*yield*/, getVagasOferta(id)];
                case 2:
                    VagasOferta_1 = _b.sent();
                    return [3 /*break*/, 8];
                case 3: return [4 /*yield*/, getVagasOferta(id, 'Fechado')];
                case 4:
                    VagasOferta_1 = _b.sent();
                    return [3 /*break*/, 8];
                case 5: return [4 /*yield*/, getVagasOferta(id, 'Semiaberto')];
                case 6:
                    VagasOferta_1 = _b.sent();
                    return [3 /*break*/, 8];
                case 7:
                    {
                        alert('Sem permissão de Regimes para a funcionalidade de Seleção de Profissionais');
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 8];
                case 8:
                    if (VagasOferta_1.Status == STATUS_API.ERRO) {
                        alert(VagasOferta_1.Mensagem);
                        return [2 /*return*/];
                    }
                    else {
                        setOferta(VagasOferta_1);
                        setVagasOferta(VagasOferta_1.vagas);
                    }
                    return [3 /*break*/, 10];
                case 9:
                    // Tela aberta sem id de oferta (ex.: URL .../vagas/cadastrar digitada
                    // direto): não há o que selecionar. Volta para a lista em vez de mostrar
                    // "ID da Oferta não informada".
                    navigate(ROUTES.SELECAO_PROFISSIONAIS, { replace: true });
                    return [2 /*return*/];
                case 10:
                    setLoadingInicio(false);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var COLUNAS_TERMOS = [
        {
            field: 'id',
            headerName: 'Código',
            width: 100,
            valueGetter: function (value) { return "".concat(getCodigoOfertaFormatada(id), "-").concat(value); },
        },
        {
            field: 'descricao',
            headerName: 'Descrição',
            width: 200,
        },
        {
            field: 'perfil_laboral_id',
            headerName: 'Perfil',
            width: 150,
            valueGetter: function (_value, row) { var _a; return (_a = row.perfil_laboral) === null || _a === void 0 ? void 0 : _a.nome; },
        },
        {
            field: 'salario',
            headerName: 'Salário',
            width: 100,
        },
        {
            field: 'jornada_trabalho_id',
            headerName: 'Jornada',
            width: 150,
            valueGetter: function (_value, row) { var _a; return (_a = row.jornada_trabalho) === null || _a === void 0 ? void 0 : _a.nome; },
        },
        {
            field: 'quantidade_vagas',
            headerName: 'Quantidade',
            width: 150,
        },
        {
            field: 'regime_reclusao_atual_id',
            headerName: 'Regime de Pena',
            width: 150,
            valueGetter: function (_value, row) { var _a; return (_a = row.regime_reclusao_atual) === null || _a === void 0 ? void 0 : _a.nome; },
        },
        {
            field: 'tipo_status_vaga',
            headerName: 'Status',
            width: 250,
        },
        {
            field: 'Opções',
            headerName: '',
            align: 'right',
            flex: 1,
            minWidth: 80,
            renderCell: function (params) {
                var _a, _b;
                return (_jsxs(Box, __assign({ flex: 1, display: 'flex', justifyContent: 'flex-end' }, { children: [_jsx(Tooltip, __assign({ title: 'Seleção', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(Box, __assign({ bgcolor: ((_a = params.row) === null || _a === void 0 ? void 0 : _a.tipo_status_vaga) == 'ENCERRADA' ? 'grey' : 'terceary.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 1, marginTop: -1 }, onClick: function () {
                                        var _a;
                                        ((_a = params.row) === null || _a === void 0 ? void 0 : _a.tipo_status_vaga) == 'ENCERRADA' ? {} : abrirPopup(params.row);
                                    } }, { children: _jsx(PersonAddAltIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })) })), _jsx(Tooltip, __assign({ title: 'Alterar', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(Box, __assign({ bgcolor: ((_b = params.row) === null || _b === void 0 ? void 0 : _b.tipo_status_vaga) == 'ENCERRADA' ? 'grey' : 'secondary.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () {
                                        var _a;
                                        ((_a = params.row) === null || _a === void 0 ? void 0 : _a.tipo_status_vaga) == 'ENCERRADA' ? {} : navigate("".concat(ROUTES.OFERTAS_VAGAS_TRABALHO, "/").concat(params.row.oferta_id, "/").concat(MODOS.ALTERAR));
                                    } }, { children: _jsx(ModeEditOutlinedIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })) }))] })));
            },
        },
    ];
    var abrirPopup = function (Vaga) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setVagaSelecionada(Vaga);
            setPopupAberto(true);
            return [2 /*return*/];
        });
    }); };
    var handleClose = function () {
        setPopupAberto(false);
        carregarDados();
    };
    var abrirPopupFinalizar = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (VagasSelecionadasGrid.length <= 0) {
                alert('Nenhuma vaga selecionada');
                return [2 /*return*/];
            }
            setPopupFinalizarAberto(true);
            return [2 /*return*/];
        });
    }); };
    var handleSalvarEncerrar = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Resp, VagasOfertaAtualizadas;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPopupFinalizarAberto(false);
                    setLoading(true);
                    return [4 /*yield*/, encerrarVagas(VagasSelecionadasGrid, ObservacaoEncerramento)];
                case 1:
                    Resp = _a.sent();
                    if (Resp.Status == STATUS_API.OK) {
                        alert('Vagas encerradas com sucesso');
                        VagasOfertaAtualizadas = VagasOferta.map(function (vaga) {
                            if (VagasSelecionadasGrid.includes(vaga.id)) {
                                vaga.tipo_status_vaga = 'ENCERRADA';
                            }
                            return vaga;
                        });
                        setVagasOferta(VagasOfertaAtualizadas);
                        setObservacaoEncerramento('');
                    }
                    else {
                        alert(Resp.Mensagem);
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(ContainerPainel, __assign({ modo: modo, pagina_acima: PAGINAS.SELECAO_PROFISSIONAIS, pagina_especifica_permissao: FUNCIONALIDADES.SELECAO_PROFISSIONAIS_VAGAS, link_pagina_acima: ROUTES.SELECAO_PROFISSIONAIS }, { children: _jsx(BoxPrincipal, __assign({ sx: { width: '100%', mt: -3 } }, { children: !LoadingInicio && (_jsxs(_Fragment, { children: [_jsxs(Box, { children: [_jsx(Typography, { variant: 'h6', gutterBottom: true }), _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsx(InputDados, { id: 'codigo-oferta', label: 'C\u00F3digo da Oferta', value: getCodigoOfertaFormatada(id), disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { id: 'descricao', label: 'Descri\u00E7\u00E3o', value: Oferta === null || Oferta === void 0 ? void 0 : Oferta.descricao, variant: 'outlined', size: 'small', disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { id: 'instituicao', label: 'Institui\u00E7\u00E3o', value: (_b = (_a = Oferta === null || Oferta === void 0 ? void 0 : Oferta.instituicao) === null || _a === void 0 ? void 0 : _a.dados) === null || _b === void 0 ? void 0 : _b.razao_social, disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsx(InputDados, { id: 'n_termo_contrato', label: 'N\u00BA Termo Contrato', value: Oferta === null || Oferta === void 0 ? void 0 : Oferta.n_termo_contrato, variant: 'outlined', size: 'small', disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsx(InputDados, { id: 'situacao_oferta', label: 'Situa\u00E7\u00E3o da Oferta', value: Oferta === null || Oferta === void 0 ? void 0 : Oferta.situacao_oferta, variant: 'outlined', size: 'small', fullWidth: true, disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsx(InputDados, { id: 'quantidade_vagas', label: 'Quantidade de Vagas', value: Oferta === null || Oferta === void 0 ? void 0 : Oferta.vagas_qtd, variant: 'outlined', size: 'small', fullWidth: true, disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsx(InputDados, { id: 'quantidade_vaga_abertass', label: 'QTD. Abertas', value: (_c = Oferta === null || Oferta === void 0 ? void 0 : Oferta.vagas_abertas) === null || _c === void 0 ? void 0 : _c.toString(), variant: 'outlined', size: 'small', fullWidth: true, disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsx(InputDados, { id: 'quantidade_vagas_p_atendidas', label: 'QTD. Atendidas Parcialmente', value: (_d = Oferta === null || Oferta === void 0 ? void 0 : Oferta.vagas_atendidas_parcialmente) === null || _d === void 0 ? void 0 : _d.toString(), variant: 'outlined', size: 'small', fullWidth: true, disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsx(InputDados, { id: 'quantidade_vagas_finalizadas', label: 'QTD. Finalizadas', value: (_e = Oferta === null || Oferta === void 0 ? void 0 : Oferta.vagas_finalizadas) === null || _e === void 0 ? void 0 : _e.toString(), variant: 'outlined', size: 'small', fullWidth: true, disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsx(InputDados, { id: 'quantidade_vagas_encerradas', label: 'QTD. Encerradas', value: (_f = Oferta === null || Oferta === void 0 ? void 0 : Oferta.vagas_encerradas) === null || _f === void 0 ? void 0 : _f.toString(), variant: 'outlined', size: 'small', fullWidth: true, disabled: true }) }))] })), _jsx(Box, __assign({ mt: 8 }, { children: _jsx(GridComp, { checkboxSelection: true, onRowSelectionModelChange: function (newRowSelectionModel) {
                                        setVagasSelecionadasGrid(newRowSelectionModel);
                                    }, rowSelectionModel: VagasSelecionadasGrid, rows: VagasOferta, columns: COLUNAS_TERMOS, loading: loading, paginationMode: 'client', onPaginationModelChange: function () { }, initialState: {
                                        sorting: {
                                            sortModel: [{ field: 'id', sort: 'asc' }],
                                        },
                                    }, isRowSelectable: function (params) { return params.row.tipo_status_vaga !== 'ENCERRADA'; } }) })), _jsxs(BoxBotoes, __assign({ sx: { marginTop: 10 } }, { children: [_jsx(BotaoFechar, { modo: modo, pagina: ROUTES.SELECAO_PROFISSIONAIS }), _jsx(BotaoAuxiliar, __assign({ backgroundColor: 'primary.main', onClick: abrirPopupFinalizar }, { children: "Encerrar Vagas" }))] }))] }), _jsxs(Dialog, __assign({ open: PopupAberto, onClose: handleClose, maxWidth: 'xl' }, { children: [_jsx(DialogContent, __assign({ style: { margin: 0 } }, { children: _jsx(ReeducandosSelecao, { vaga: VagaSelecionada }) })), _jsx(DialogActions, __assign({ style: { padding: 20 } }, { children: _jsx(Button, __assign({ onClick: handleClose }, { children: "Voltar" })) }))] })), _jsxs(Dialog, __assign({ open: PopupFinalizarAberto, onClose: handleClose, maxWidth: 'md', fullWidth: true }, { children: [_jsx(DialogTitle, { children: "Encerrar Vagas" }), _jsx(DialogContent, __assign({ style: { margin: 0 } }, { children: _jsx(Box, __assign({ mt: 1 }, { children: _jsx(InputDados, { id: 'observacao', label: 'Observa\u00E7\u00E3o', value: ObservacaoEncerramento, onChange: function (value) { return setObservacaoEncerramento(value.target.value); }, variant: 'outlined', size: 'small', multiline: true, rows: 5 }) })) })), _jsxs(DialogActions, __assign({ style: { padding: 20 } }, { children: [_jsx(Button, __assign({ onClick: function () {
                                            setPopupFinalizarAberto(false);
                                        } }, { children: "Fechar" })), _jsx(Button, __assign({ onClick: handleSalvarEncerrar }, { children: "Salvar" }))] }))] }))] })) })) })));
};
export default SelecaoVagas;
